<template>
    <div ref="chart" class="line-chart"></div>
</template>

<script>
import * as echarts from 'echarts';

export default {
    name: "LineChart",
    props: {
        xData: {
            type: Array,
            default: () => []
        },
        yData: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            chart: null
        };
    },
    mounted() {
        this.initChart();
        window.addEventListener("resize", this.resizeChart);
    },
    beforeDestroy() {
        if (this.chart) {
            this.chart.dispose();
        }
        window.removeEventListener("resize", this.resizeChart);
    },
    watch: {
        xData: "updateChart",
        yData: "updateChart"
    },
    methods: {
        initChart() {
            this.chart = echarts.init(this.$refs.chart);
            this.setOption();
        },
        setOption() {
            const option = {
                xAxis: {
                    type: "category",
                    boundaryGap: false,
                    data: this.xData,
                    // splitLine: {
                    //     show: true,
                    //     lineStyle: {
                    //         type: 'dashed' // 设置X轴网格线为虚线
                    //     }
                    // }
                },
                yAxis: {
                    type: "value",
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: 'dashed', // 设置X轴网格线为虚线
                            color: '#565e70'
                        }
                    }

                },
                grid: {
                    top: 30,
                    bottom: 20,
                    left: 0,
                    containLabel: true
                },
                series: [
                    {
                        data: this.yData,
                        type: "line",
                        areaStyle: {},
                    }
                ]
            };
            this.chart.setOption(option);
        },
        updateChart() {
            if (this.chart) {
                this.setOption();
            }
        },
        resizeChart() {
            if (this.chart) {
                this.chart.resize();
            }
        }
    }
};
</script>

<style scoped>
.line-chart {
    width: 100%;
    height: 320px;
}
</style>
